import { useTheme } from '@mui/material';
import { ScreenSizes } from '@interfaces';

export const useStyles = () => {
  const { breakpoints } = useTheme();

  return {
    root: {
      mt: 1,
    },
    scrollable: {
      maxHeight: 'calc(100vh - 226px)',
      height: 282,

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        height: 'calc(100vh - 238px)',
        maxHeight: 'calc(100dvh - 208px)',
      },
    },
    tabs: {
      '& .MuiTabs-flexContainer': {
        display: 'inline-flex',
        columnGap: 3,
        width: '100%',
      },
    },
  };
};
